module.exports = __webpack_public_path__ + "img/moneda-icon.937ec182.svg";